export const acceptedCardTypes = [
  'VI',
  'CA',
  'AX',
  'CU',
  'DC',
  'DS',
  'JC',
  'TO'
]

export const secureFieldsToBofhTypes = {
  VIS: 'VI',
  ECA: 'CA',
  AMX: 'AX',
  DIN: 'DC',
  DIS: 'DS',
  JCB: 'JC',
  CUP: 'CU',
  MAU: 'TO'
}

export const bofhToSecureFieldsTypes = {
  VI: 'VIS',
  CA: 'ECA',
  AX: 'AMX',
  DC: 'DIN',
  DS: 'DIS',
  JC: 'JCB',
  CU: 'CUP',
  TO: 'MAU'
}
